import { fetchJSON } from './utils';

function formatTicketResponseData(ticketResponse) {
    return {
        ...ticketResponse,
        to_user_ids: ticketResponse.to_user_ids || [],
        cc_user_ids: ticketResponse.cc_user_ids || [],
        bcc_user_ids: ticketResponse.bcc_user_ids || [],
        to_user_emails: ticketResponse.to_user_emails || [],
        cc_user_emails: ticketResponse.cc_user_emails || [],
        bcc_user_emails: ticketResponse.bcc_user_emails || [],
        attachments: ticketResponse.attachments || [],
    }
}

// Example usage:
// FETCH 
// ========================================================================
// const interaction_id = "f36f80c8-3408-4249-a581-59d1706a6589";
// const status = TicketResponseStatusEnum.DRAFT;
// const result = await api.ticket_responses.fetchAllTicketResponsesByInteractionIdAndStatus(interaction_id, status);
// ========================================================================
export async function fetchAllTicketResponsesByInteractionIdAndStatus(interaction_id, status) {
    const url = `/api/ticket_responses/interaction/${interaction_id}?status=${status}`;
    const resp = await fetchJSON(url, null, null, "get");
    return resp.data.map(formatTicketResponseData);
}


// general way to fetch ticket responses 
export async function fetchTicketResponsesByInteractionId(interaction_id, body) {
    const url = `/api/ticket_responses/interaction/${interaction_id}`;
    const res = await fetchJSON(url, null, body, "post");
    return res.data.map(formatTicketResponseData)
}

export async function getTicketResponsesByThreadId(
  {
    threadId,
    redirectUrls = false,
    includeUsers = true,
  }
) {
  const url = `/api/ticket_responses/threads/?thread_id=${threadId}`;
  const res = await fetchJSON(
    url,
    {
      redirect_url: redirectUrls,
      include_users: includeUsers,
    },
  );
  
  const ticketResponses = res.data.map(formatTicketResponseData);
  if (!includeUsers) return ticketResponses;

  for (const ticketResponse of ticketResponses) {
    ticketResponse.participants = [];
    for (const participant of res.users) {
      if (
        ticketResponse.interaction_user_id === participant.id ||
        ticketResponse.user_id === participant.id ||
        ticketResponse.to_user_ids.includes(participant.id) ||
        ticketResponse.cc_user_ids.includes(participant.id) ||
        ticketResponse.bcc_user_ids.includes(participant.id)
      ) {
        ticketResponse.participants.push(participant);
      }
    }
  }

  return ticketResponses;
}

// Example usage:
// CREATE
// ========================================================================
// const data = {
//   interaction_id: "f36f80c8-3408-4249-a581-59d1706a6589",
//   to_user_ids: ["gurkaran-test-user-id-interactions-around"],
//   response_text: "test response - gk test - DRAFT 2",
//   status: TicketResponseStatusEnum.LIVE, // or "DRAFT"
//   has_attachment: false,
//   attachment_media_type: null, 
//   relevant_interactions: [""]
// const result = await api.ticket_responses.createTicketResponse(data);
// ========================================================================
export async function createTicketResponse(data) {
    const url = "/api/ticket_responses/";
    const res = await fetchJSON(url, null, data, "post");
    return formatTicketResponseData(res.data);
}

// Uses a different endpoint to create a ticket response from a user, not from an agent
// Seems unused, only caller InteractionConversationsComposeFormReadOnly.vue is unused.
export async function createUserTicketResponse(data) {
    const url = "/api/ticket_responses/users";
    const res = await fetchJSON(url, null, data, "post");
    return formatTicketResponseData(res.data);
}


// UPDATE
// ========================================================================
// const id = "d068ae4c-a01c-4346-9371-3674210f878a"; // Replace with a DRAFT id 
// const data = {
//   status: "LIVE", // or other fields you want to update
// };
// const result = await api.ticket_responses.updateTicketResponse(id, data);
// console.log("Updated Ticket Response:", result);
// ========================================================================
export async function updateTicketResponse(id, data) {
    const url = `/api/ticket_responses/${id}`;
    const res = await fetchJSON(url, null, data, "put");
    return formatTicketResponseData(res.data);
}

export function deleteTicketDraftResponse(id) {
    const url = `/api/ticket_responses/${id}`;
    return fetchJSON(url, null, null, "delete");
}

export function getPresignedUrl(file_name, mimetype) {
    const url = `/api/ticket_responses/upload/presignedurl`;
    const params = {
        file_name: file_name,
        mimetype: mimetype
    }
    return fetchJSON(url, params, null, "get");
}

/**
 * Mark a ticket response as seen in the backend
 * @param {string} id is the ticket reponse id
 * @returns 
 */
export function markAsSeen(id) {
    const url = `/api/ticket_responses/seen/${id}`;
    return fetchJSON(url, null, null, "put");
}

export function fetchTicketResponsesByInteractionIds(params) {
    const url = `/api/ticket_responses/interactions/`

    return fetchJSON(url, params, null, "get")
}
